import script from "./ProcessUsersList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProcessUsersList.vue?vue&type=script&lang=ts&setup=true"

import "./ProcessUsersList.vue?vue&type=style&index=0&id=43fae721&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43fae721"]])

export default __exports__